collectSelectionsToResolve